import React from "react";
import { breadcrumbs } from "../../common/breadcrumbs";
import { TopBanner } from "../../common/TopBanner";
import { Link } from "../../lib/Link";


export class NotFound extends React.Component {
  static countOfComponent = 0;
  componentDidMount() {
    this.updatedCountOfComponent(1);
  }
  componentWillUnmount(){
    this.updatedCountOfComponent(-1);
  }
  updatedCountOfComponent (sign) {
    if(sign > 0) {
      if(NotFound.countOfComponent === 0) {
        const element = document.createElement('meta');
        element.setAttribute('name', 'prerender-status-code');
        element.setAttribute('content', '404');
        document.head.appendChild(element);
      }
      NotFound.countOfComponent += 1;
    } else {
      NotFound.countOfComponent -= 1;
      if(NotFound.countOfComponent === 0) {
        const element = Array.from(document.getElementsByTagName('meta')).find((element) => element.getAttribute('name') === 'prerender-status-code');
        document.head.removeChild(element);       
      }
    }
  }
  render () {
    document.title = 'トランクルームをお探しなら『ハローストレージ』【公式】｜ページが見つかりません';
    return (
      <div className="container">
        <div className="notfound">
          <h3>お探しのページが見つかりません。</h3>
          <Link to="/" className="link">
            &lt;&lt;トップページへ戻る
          </Link>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./pages/notFound/NotFound.jsx